export default function ProgressBar({ width, active }) {
  return (
    <div
      className={`progress-bar ${active ? "active" : ""}`.trim()}
      style={{ width: active ? `${width}%` : "0%" }}
      aria-hidden="true"
    />
  );
}
